import { useEffect, useState } from 'react'
import { checkResolveSymbol, checkObliqueLine } from '@src/containers/UtmGenerator/helpers'

export function useUtmUserLink(
  linkPage,
  protocol,
  utmSource,
  utmMedium,
  utmCampaign,
  utmContent,
  utmTerm
): [string] {
  const [userUtmLink, setUTMLink] = useState('')

  useEffect(() => {
    const arrParameters = [utmSource, utmMedium, utmCampaign, utmContent, utmTerm]

    const [link, anchor] = linkPage.split('#')

    const fullUTMLink = arrParameters
      .filter(item => item.value)
      .reduce((acc, item, idx) => {
        const separator = !!idx || linkPage.includes('?') ? '&' : '?'
        return acc + separator + `${item.name}=${checkResolveSymbol(item.value)}`
      }, `${protocol}://${linkPage ? link : `site.ru`}`)

    setUTMLink(checkObliqueLine(fullUTMLink + (anchor ? `#${anchor}` : ''), protocol))
  }, [linkPage, protocol, utmSource, utmMedium, utmCampaign, utmContent, utmTerm])

  return [userUtmLink]
}
